/*
 * CKEditor input for Jeditable
 * 
 * Adapted from Wysiwyg input for Jeditable by Mike Tuupola
 *   http://www.appelsiini.net/2008/9/wysiwyg-for-jeditable
 *
 * Copyright (c) 2009 Jeremy Bell
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 * 
 * Depends on CKEditor:
 *   http://ckeditor/
 *
 * Revision: $Id$
 *
 */
import _ from 'underscore';
import md5 from 'md5';
import JEditable from "jqueryEditable";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

(async function ($) {
    const customFields = await $.getDefaultQ('/CampaignCloud/CustomFields');

    class CKEEditable extends CustomTagEditable {
        /* Use default textarea instead of writing code here again. */

        //element : JEditable.types.textarea.element,
        element(settings, original) {
            /* Hide textarea to avoid flicker. */
            console.log(original);
            var textarea = $('<textarea id="wysiwyg-editable">').css("opacity", "0");
            if (settings.rows) {
                textarea.attr('rows', settings.rows);
            } else {
                textarea.height(settings.height);
            }
            if (settings.cols) {
                textarea.attr('cols', settings.cols);
            } else {
                textarea.width(settings.width);
            }
            $(this).append(textarea);
            return (textarea);
        }

        content(string, settings, original) {
            $('textarea', this).text(string);
        }

        plugin(settings, original) {
            var self = this;
            //TODO change conditions and response
            // Custom Field Tags
            try {
                if (settings) {
                    setTimeout(setUpEditor.bind(self, settings), 0);
                } else {
                    setTimeout(() => CKEDITOR.replace($('textarea', self).attr('id')), 0);
                }
            } catch (e) {
                console.error(e);
            }
        }

        submit(settings, original) {
            const $textarea = $('textarea', this);
            const instance = CKEDITOR.instances[$textarea.attr('id')];
            const data = instance.getData();
            $textarea.val($.clearHtmlScripts(data));
            instance.destroy();
        }
    }


    JEditable.addInputType('wysiwyg', CKEEditable);

    async function setUpEditor(settings) {
        let self = this;
        const config = settings.fullHtml ?
            require('js/adapters/ckeditor.full.config').default
            : require("js/adapters/ckeditor.simple.config").default;

        const editor = CKEDITOR.replace($('textarea', self).attr('id'), config);

        if (!settings.fullHtml) return;

        const parent = settings.parent;
        //Localization
        CKEDITOR.config.language = parent.i18n.language;
        CKEDITOR.tools.i18n = parent.i18n;
        adjustUI(editor, parent);

        CKEDITOR.instances["wysiwyg-editable"].on('drop', function (e) {
            //e.stop;
            //detect if file was dropped from outside
            if (editor.dragFromOutside) {
                var files = [].slice.call(e.data.$.dataTransfer.files);
                files.forEach(handleUpload.bind(self, parent, editor));
            } else {
                editor.dragFromOutside = true;
            }
        });

        editor.on('paste', function (e) {
            var text = e.data.dataValue;
            if (text.length > 50000) {
                e.stop();
                $(self).trigger("jWysiwyg.tooBigPaste");
            }
        });

    }

    function handleUpload(parent, editor, file) {
        if (!file.type.startsWith("image/")) {
            $(self).trigger("jWysiwyg.notImageDrop");
        } else {
            var fileReader = new window.FileReader();
            fileReader.onload = handleFile.bind(this, parent, editor, file);
            fileReader.readAsBinaryString(file);
        }
    }

    async function handleFile(parent, editor, file, e) {
        var checksum = md5(e.target.result);
        console.log(`MD5 = ${checksum}`);
        try {
            const md5Exists = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Content/md5exists/${checksum}`,
                type: 'GET',
                dataType: 'json'
            });
            let existingId = md5Exists.id;
            console.log(`id = ${existingId}`);
            if (!existingId) {
                const imageUploadUrl = '/CampaignCloud/Content/UploadContent';
                let data = new FormData();
                data.append('files[]', file);
                const uploadNotification = new CKEDITOR.plugins
                    .notification(editor, parent.i18n.t("content.uploading"));
                uploadNotification.show();
                const uploadStatus = await $.ajaxDefaultQ({
                    url: imageUploadUrl,
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST'
                });
                let us = JSON.parse(uploadStatus);
                console.log(us);
                if (us.status == "success") {
                    editor.insertHtml(`<img src='/CampaignCloud/Content/LoadFileContentBytes/${us.contentId}' />`);
                    editor.getSelection().removeAllRanges();
                    uploadNotification.update({
                        type: "success",
                        message: parent.i18n.t("content.fileuploaded")
                    });
                } else {
                    console.error("!");
                    uploadNotification.update({
                        type: "error",
                        message: parent.i18n.t("content.failed")
                    });
                }
            } else {
                editor.insertHtml(`<img src='/CampaignCloud/Content/LoadFileContentBytes/${existingId}' />`);
                editor.getSelection().removeAllRanges();
            }
        } catch (e) {
            console.error(e);
        }
    }

    function adjustUI(editor, parent) {
        // CUSTOM BUTTONS
        editor.addCommand("addNameTag", {
            exec: function (edt) {
                parent.customExec(edt, "{subscriber.name}");
            }
        });
        editor.ui.addButton('NameButton', {
            label: parent.i18n.t('subscriber.firstname'),
            command: 'addNameTag',
            toolbar: 'tellodytags'
        });

        editor.addCommand("addSurnameTag", {
            exec: function (edt) {
                parent.customExec(edt, "{subscriber.surname}");
            }
        });
        editor.ui.addButton('SurnameButton', {
            label: parent.i18n.t('subscriber.lastname'),
            command: 'addSurnameTag',
            toolbar: 'tellodytags'
        });
        if (CKEDITOR.config.language == "el") {
            editor.addCommand("addNameVocTag", {
                exec: function (edt) {
                    parent.customExec(edt, "{subscriber.name_voc}");
                }
            });
            editor.ui.addButton('NameVocButton', {
                label: parent.i18n.t('subscriber.firstname_voc'),
                command: 'addNameVocTag',
                toolbar: 'tellodytags',
                icon: 'tellodybuttons/speaking.svg'
            });
            editor.addCommand("addSurnameVocTag", {
                exec: function (edt) {
                    parent.customExec(edt, "{subscriber.surname_voc}");
                }
            });
            editor.ui.addButton('SurnameVocButton', {
                label: parent.i18n.t('subscriber.lastname_voc'),
                command: 'addSurnameVocTag',
                toolbar: 'tellodytags',
                icon: 'tellodybuttons/speaking.svg'
            });
        }

        editor.addCommand("addProfessionTag", {
            exec: function (edt) {
                parent.customExec(edt, "{subscriber.profession}");
            }
        });
        editor.ui.addButton('ProfessionButton', {
            label: parent.i18n.t('subscriber.profession'),
            command: 'addProfessionTag',
            toolbar: 'tellodytags'
        });

        editor.addCommand("addAddressTag", {
            exec: function (edt) {
                parent.customExec(edt, "{subscriber.address}");
            }
        });
        editor.ui.addButton('AddressButton', {
            label: parent.i18n.t('subscriber.address'),
            command: 'addAddressTag',
            toolbar: 'tellodytags'
        });

        _.each(customFields, function (customField) {
            editor.addCommand("addCF" + customField.id + "Tag", {
                exec: function (edt) {
                    parent.customExec(edt, "{customfield" + customField.id + "}");
                }
            });
            editor.ui.addButton('CF' + customField.id + 'Button', {
                label: customField.name,
                command: 'addCF' + customField.id + 'Tag',
                toolbar: 'tellodytags'
            });
        });

        editor.addCommand("addGenderMTag", {
            exec: function (edt) {
                parent.customGenderExec(edt, "[M[" + parent.i18n.t("subscriber.genderDefault") + "]]");
            }
        });
        editor.ui.addButton('GenderMButton', {
            label: parent.i18n.t('subscriber.genderIfMale'),
            command: 'addGenderMTag',
            toolbar: 'genderTags',
            icon: 'tellodybuttons/maleIcon.svg'
        });
        editor.addCommand("addGenderFTag", {
            exec: function (edt) {
                parent.customGenderExec(edt, "[F[" + parent.i18n.t("subscriber.genderDefault") + "]]");
            }
        });
        editor.ui.addButton('GenderFButton', {
            label: parent.i18n.t('subscriber.genderIfFemale'),
            command: 'addGenderFTag',
            toolbar: 'genderTags',
            icon: 'tellodybuttons/femaleIcon.svg'
        });
        editor.addCommand("addGenderOTag", {
            exec: function (edt) {
                parent.customGenderExec(edt, "[O[" + parent.i18n.t("subscriber.genderDefault") + "]]");
            }
        });
        editor.ui.addButton('GenderOButton', {
            label: parent.i18n.t('subscriber.genderIfOther'),
            command: 'addGenderOTag',
            toolbar: 'genderTags',
            icon: 'tellodybuttons/otherGenderIcon.svg'
        });
        editor.addCommand("addGenderNTag", {
            exec: function (edt) {
                parent.customGenderExec(edt, "[N[" + parent.i18n.t("subscriber.genderDefault") + "]]");
            }
        });
        editor.ui.addButton('GenderNButton', {
            label: parent.i18n.t('subscriber.genderIfNone'),
            command: 'addGenderNTag',
            toolbar: 'genderTags',
            icon: 'tellodybuttons/noGenderIcon.svg'
        });
        editor.addCommand("addOptoutLink", {
            exec: function (edt) {
                parent.customUurlExec(edt, "{UURL.optout}", parent.i18n.t("message.optoutlink"));
            }
        });
        editor.ui.addButton('OptoutButton', {
            label: parent.i18n.t('message.optout'),
            command: 'addOptoutLink',
            toolbar: 'tellodylinks',
            icon: 'tellodybuttons/optout.svg'
        });
        editor.addCommand("addUpdateProfileLink", {
            exec: function (edt) {
                parent.customUurlExec(edt, "{profileHash}", parent.i18n.t("message.updateProfileLink"));
            }
        });
        editor.ui.addButton('UpdateProfileButton', {
            label: parent.i18n.t('message.updateProfile'),
            command: 'addUpdateProfileLink',
            toolbar: 'tellodylinks',
            icon: 'tellodybuttons/archive.svg'
        });

        editor.addCommand("addFile", {
            exec: function (edt) {
                parent.customUurlExec(edt, "{UURL.download}", parent.i18n.t("message.filelink"));
            }
        });
        editor.ui.addButton('FileButton', {
            label: parent.i18n.t('message.file'),
            command: 'addFile',
            toolbar: 'tellodylinks',
            icon: 'tellodybuttons/file.svg'
        });

        editor.addCommand("addVoucher", {
            exec: function (edt) {
                parent.customUurlExec(edt, "{UURL.voucher}", parent.i18n.t("message.voucherlink"));
            }
        });
        editor.ui.addButton('VoucherButton', {
            label: parent.i18n.t('message.voucher'),
            command: 'addVoucher',
            toolbar: 'tellodylinks',
            icon: 'tellodybuttons/voucher.svg'
        });

        editor.addCommand("addSurvey", {
            exec: function (edt) {
                parent.customUurlExec(edt, "{UURL.survey}", parent.i18n.t("message.surveylink"));
            }
        });
        editor.ui.addButton('SurveyButton', {
            label: parent.i18n.t('surveytitle'),
            command: 'addSurvey',
            toolbar: 'tellodylinks',
            icon: 'tellodybuttons/survey.svg'
        });

        editor.on('key', function (e) {
            parent.isTriggeredByKeyPress = true;
            parent.isMessageSaved = false;
        });

        editor.dragFromOutside = true;

        editor.on('dragstart', function (e) {
            editor.dragFromOutside = false;
        });
    }
})(jQuery);